import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/eds-button';
import { Icon } from '@eventbrite/eds-icon';
import { LogoApple } from '@eventbrite/eds-iconography';

import { SIZE_BLOCK, STYLE_NEUTRAL } from '@eventbrite/eds-button';

import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    DATA_HEAP_ID_LOGIN_WITH_APPLE_BUTTON,
} from './constants';

import { buildAppleLoginResponse, injectScriptTag } from './utils';
import AppleIconSvg from './icons/AppleIcon';
import './AppleLoginButton.scss';
import './SocialLoginButton.scss';

export default class AppleLoginButton extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,
        clientId: PropTypes.string,
        scope: PropTypes.string,
        redirectURI: PropTypes.string,
        asyncStrategy: PropTypes.string,
    };

    componentDidMount() {
        const { asyncStrategy, skipScriptLoading } = this.props;

        if (!skipScriptLoading) {
            injectScriptTag({
                doc: document,
                id: 'apple-id-auth',
                src: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                asyncStrategy,
                onLoad: this.appleInit,
            });
        }
    }

    /* istanbul ignore next */
    appleInit = () => {
        const { clientId, scope, redirectURI } = this.props;

        if (this.areParametersValid()) {
            window?.AppleID?.auth?.init?.({
                clientId,
                scope,
                redirectURI,
                usePopup: true,
            });
        }
    };

    handleOnClick = () => {
        const {
            onClick,
            onSocialConnectVerified,
            onSocialConnectNotAuthorized,
        } = this.props;

        onClick?.(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE);

        window?.AppleID?.auth
            ?.signIn?.()
            .then((response) => {
                const parsedResponse = buildAppleLoginResponse(response);

                onSocialConnectVerified?.(
                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                    parsedResponse,
                );
            })
            .catch((status) => {
                /**
                 * error: The returned error code. (currently only: `user_cancelled_authorize`)
                 * state: The state passed by the init function.
                 *  {
                         "error": "[ERROR_CODE]"
                    }
                    */
                onSocialConnectNotAuthorized?.(
                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                    {
                        sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                        status,
                    },
                );
            });
    };

    areParametersValid = () => {
        const { clientId, redirectURI } = this.props;

        return clientId && redirectURI;
    };

    render() {
        const { buttonAppleText, isSecondary } = this.props;
        const buttonText = buttonAppleText || gettext('Continue with Apple');
        let appleButton = (
            <div className="social-login__container">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.handleOnClick}
                    disabled={!this.areParametersValid()}
                    style={STYLE_NEUTRAL}
                    data-heap-id={DATA_HEAP_ID_LOGIN_WITH_APPLE_BUTTON}
                >
                    <div className="apple-login__icon">
                        <Icon type={<LogoApple />} size="small" />
                    </div>
                    <div className="apple-login__text">{buttonText}</div>
                </Button>
            </div>
        );
        if (isSecondary) {
            appleButton = (
                <Button
                    type="button"
                    style="none"
                    onClick={this.handleOnClick}
                    disabled={!this.areParametersValid()}
                    data-heap-id={DATA_HEAP_ID_LOGIN_WITH_APPLE_BUTTON}
                >
                    <Icon
                        type={<AppleIconSvg />}
                        isBlockLevel={true}
                        size="medium"
                    />
                    <div className="eds-is-hidden-accessible">{buttonText}</div>
                </Button>
            );
        }
        return appleButton;
    }
}
